import { useEffect, useState, useRef } from "react";
import axios from "axios";

import {
  MainContainer,
  GuestCard,
  GuestImage,
  GuestName,
  WaitingContainer,
  MdesLogo,
  MastercardLogo,
  WaitingText,
  FullscreenWrapper,
} from "./styles/CheckInUsersStyles";

import mdesLogo from "./img/mdes_logo.png";
import masterCardLogo from "./img/mastercard_logo.png";
import { sleep } from "../../utils/utils";
import { PLACEHOLDER } from "./styles/CheckInUsersWallStyles";

const GuestQueue = ({ eventId }) => {
  const [queue, setQueue] = useState([]);
  const [currentGuest, setCurrentGuest] = useState(null);
  const displayInterval = useRef(null);
  const pollingActive = useRef(true);
  // Removed unused isFullscreen state

  const displayIntervalTime = 5000; // 5 seconds
  const pollingIntervalTime = 500; // 0.5 seconds between polls

  // Polling backend

  const containerRef = useRef(null);

  useEffect(() => {
    const handleKeyDown = (e) => {
      // Alt + Enter
      if (e.altKey && e.key === "Enter") {
        toggleFullscreen();
        e.preventDefault(); // stop default behavior
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const toggleFullscreen = () => {
    const el = containerRef.current;
    if (!el) return;

    if (!document.fullscreenElement) {
      el.requestFullscreen();
    } else {
      document.exitFullscreen();
    }
  };

  useEffect(() => {
    // Optionally, you can handle fullscreen change here if needed
  }, []);

  useEffect(() => {
    const pollQueue = async () => {
      if (!pollingActive.current) return; // stop polling

      const url = `https://www.manage-mii.uk/api/das/guests/event-queue/mastercard_mdes_25`;

      try {
        const response = await axios.get(url);

        if (response.status >= 400) {
          console.error("API returned error", response.status);
          if (pollingActive.current) setTimeout(pollQueue, 5000); // retry slower
          return;
        }

        if (response.data && response.data.length > 0) {
          setQueue((prev) => [...prev, ...response.data]);
        }

        // ✅ schedule next poll normally
        if (pollingActive.current) setTimeout(pollQueue, pollingIntervalTime);
      } catch (err) {
        console.error("Error fetching guest queue:", err);
        if (pollingActive.current) setTimeout(pollQueue, 5000); // retry slower
        return;
      }
    };

    pollQueue();

    return () => {
      pollingActive.current = false;
    };
  }, []);

  // Cycle through guests every 5 seconds
  useEffect(() => {
    if (queue.length === 0) {
      setCurrentGuest(null); // no guests
      return;
    }

    // Display the first guest
    setCurrentGuest(queue[0]);

    // Schedule next guest display
    const timeout = setTimeout(() => {
      setQueue((prevQueue) => prevQueue.slice(1));
    }, displayIntervalTime);

    return () => clearTimeout(timeout);
  }, [queue, displayIntervalTime]);

  return (
    <FullscreenWrapper ref={containerRef}>
      <MainContainer>
        {currentGuest ? (
          <GuestCard>
            <GuestImage
              src={currentGuest.guestPhotoURL ?? PLACEHOLDER}
              alt={currentGuest.guestFirstName}
            />
            <GuestName>{currentGuest.guestFirstName}</GuestName>
          </GuestCard>
        ) : (
          <WaitingContainer>
            <MdesLogo
              src={mdesLogo}
              alt="mdesLogo"
              onClick={() => toggleFullscreen()}
            />
            <MastercardLogo src={masterCardLogo} alt="mdesLogo" />

            <WaitingText>MDES Town Hall</WaitingText>
            <WaitingText>September 18, STL Cafeteria</WaitingText>
          </WaitingContainer>
        )}
      </MainContainer>
    </FullscreenWrapper>
  );
};

export default GuestQueue;
